import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dirty-element"
export default class DirtyElementController extends Controller {

	static outlets = ['dirty-element-present']
	static targets = ['element']

	elementTargetConnected(target) {
		this.updateInputDirtyness(target)
	}

	updateDirtyness(event) {
		this.updateInputDirtyness(event.currentTarget)
	}

	updateInputDirtyness(input) {
		if (DirtyElementController.isInputDirty(input)) {
			input.dataset.elementIsDirty = 'true'
			this.dirtyElementPresentOutlets.forEach(outlet => outlet.addDirtyElement(input))
		} else { 
			input.dataset.elementIsDirty = 'false'
			this.dirtyElementPresentOutlets.forEach(outlet => outlet.deleteDirtyElement(input))
		}
	}

	static isInputDirty(input) {
		if (!input) { return false }

		const originalValue = input.dataset.originalValue || ""
		const currentValue = input.innerText.trim()

		if (input.dataset.markedForCreation === '1' || originalValue !== currentValue || input.dataset.markedForDestruction === '1') {
			return true
		} else {
			return false
		}
	}

}
